<template>
  <tr
    class="hover:bg-gray-100 transition-colors duration-150 ease-in-out text-right child:py-4 first-child:pl-16 last-child:pr-3 text-sm"
    :class="
      {
        'bg-gray-50 border-gray-100': depth <= 1,
        'bg-gray-200 border-gray-300': depth === 2,
        'bg-gray-300 border-gray-400': depth === 3,
        'bg-gray-400 border-gray-500': depth >= 4
      }
    "
  >
    <td
      class="py-3 text-left"
    >
      <div
        class="flex items-center space-x-2"
        :style="{ paddingLeft: `${(depth * 20) + 16}px` }"
      >
        <span
          class="font-semibold text-gray-900"
        >{{ $props.packageTradeItem.billItem }}</span>

        <span
          v-if="wbsCode"
          class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded ml-2"
        >
          {{ wbsCode.code }}
        </span>

        <ProvisionalSumBadge
          v-if="tradeItem.is_provisional_sum"
        />

        <p class="w-32 text-gray-700">
          {{ tradeItem.name }}
        </p>
      </div>
    </td>

    <td class="">
      <div class="flex items-center justify-end">
        <button
          v-if="showBudgetCommentButton"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          :aria-label="varianceComment ? $t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.editComment') : $t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.addComment')"
          @click.stop="editBudgetComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <button
          v-else-if="!!varianceComment?.body"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          @click.stop="showBudgetcomment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div :title="showBudgetCommentTooltip ? varianceComment.body : ''">
          {{ australianNumber(packageTradeItem.quantity) }} {{ tradeItem.unit }}

          <p class="text-xs text-gray-600">
            {{ $tcc(packageTradeItem.value) }}
          </p>
        </div>
      </div>
    </td>

    <td class="pr-3">
      {{ australianCurrency(packageTradeItem.rate) }}/{{ tradeItem.unit }}
    </td>

    <td
      v-if="!falsey(ratesCost?.current_quantity) && canEditClaim && !typingClaim"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-green-200/50"
      @click="typeClaim"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('Subcontract.SubcontractorClaimShow.RatesTradeRowItem.accessibility.removeClaim')"
          @click.stop.capture="removeClaim"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>

        <span class="ml-2">
          {{ !falsey(ratesCost?.current_quantity) ? $tn(ratesCost.current_quantity) : '' }}{{ tradeItem.unit }}

          <p
            v-if="ratesCost?.current_quantity"
            class="text-xs text-gray-600"
          >
            {{ $tcc(ratesCost?.current_quantity * packageTradeItem.rate) }}
          </p>
        </span>
      </div>
    </td>

    <td
      v-else-if="canEditClaim"
      class="bg-green-200/50"
    >
      <div class="flex items-center space-x-2 justify-end">
        <AppInput
          ref="claimInput"
          v-model.number="costForm.form.current_quantity"
          name="current_quantity"
          type="number"
          min="1"
          class="w-20 h-6 form-input"
          @blur="stopTypingClaim"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingClaim = false"
        />

        <span class="text-xs text-gray-600">{{ tradeItem.unit }}</span>
      </div>
    </td>

    <td
      v-else
      class="bg-green-200/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.RatesTradeRowItem.accessibility.currentClaim') + ': ' + (!falsey(ratesCost?.current_quantity) ? $tcc(ratesCost.current_quantity) : '')"
    >
      {{ !falsey(ratesCost?.current_quantity) ? `${australianNumber(ratesCost.current_quantity)}${tradeItem.unit}` : '' }}
      <p
        v-if="ratesCost?.current_quantity"
        class="text-xs text-gray-600"
      >
        {{ $tcc(ratesCost?.current_quantity * packageTradeItem.rate) }}
      </p>
    </td>

    <template v-if="liteMode">
      <td
        v-if="!falsey(ratesCost?.current_certified) && !typingCertified && canEditCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-green-200/50"
        @click="typeCertified"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.removeCertified')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.editCertified')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>

          <span>

            {{ !falsey(ratesCost.current_certified) ? `${$tn(ratesCost.current_certified)}${tradeItem.unit}` : '' }}
            <p
              v-if="ratesCost?.current_certified"
              class="text-xs text-gray-600"
            >
              {{ $tcc(ratesCost?.current_certified * packageTradeItem.rate) }}
            </p>
          </span>
        </div>
      </td>

      <td
        v-else-if="canEditCertified"
        class="bg-green-200/50"
      >
        <div class="flex items-center space-x-2 justify-end">
          <AppInput
            ref="certifiedInput"
            v-model.number="costForm.form.current_certified"
            name="current_certified"
            type="number"
            class="w-20 h-6 form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="resetTypingCertified"
          />

          <span class="text-xs text-gray-600">{{ tradeItem.unit }}</span>
        </div>
      </td>

      <td
        v-else
        class="bg-green-200/50"
      >
        {{ !falsey(ratesCost?.current_certified) ? `${$tn(ratesCost.current_certified)}${tradeItem.unit}` : '' }}
        <p
          v-if="ratesCost?.current_certified"
          class="text-xs text-gray-600"
        >
          {{ $tcc(ratesCost?.current_certified * packageTradeItem.rate) }}
        </p>
      </td>
    </template>

    <template v-else>
      <td
        v-if="!falsey(ratesCost?.current_certified) && !typingCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-green-200/50"
        @click="typeCertified"
      >
        <div class="group flex items-center justify-end">
          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(ratesCost.current_certified) ? `${$tn(ratesCost.current_certified)}${tradeItem.unit}` : '' }}
        </div>

        <p
          v-if="!falsey(ratesCost.current_certified)"
          class="text-xs text-gray-600"
        >
          {{ $tcc(ratesCost.current_certified * packageTradeItem.rate) }}
        </p>
      </td>

      <td
        v-else-if="canEditCertified && ratesCost?.current_quantity"
        class="bg-green-200/50"
      >
        <div class="flex items-center space-x-2 justify-end">
          <AppInput
            ref="certifiedInput"
            v-model.number="costForm.form.current_certified"
            name="current_certified"
            type="number"
            min="0"
            class="w-20 h-6 form-input"
            @blur="stopTypingCertified"
            @keyup.enter="stopTypingCertified"
            @keyup.esc="typingCertified = false"
          />

          <span class="text-xs text-gray-600">{{ tradeItem.unit }}</span>
        </div>
      </td>

      <td
        v-else
        class="bg-green-200/50"
      >
        {{ !falsey(ratesCost?.current_certified) ? `${$tn(ratesCost.current_certified)}${tradeItem.unit}` : '' }}
        <p
          v-if="!falsey(ratesCost?.current_certified)"
          class="text-xs text-gray-600"
        >
          {{ $tcc(ratesCost.current_certified * packageTradeItem.rate) }}
        </p>
      </td>
    </template>

    <td
      class="group bg-green-200/50"
      :class="{ 'text-red-600': hasVariance && variance !== 0 }"
      :title="hasVariance && variance !== 0 && varianceComment?.body ? varianceComment.body : ''"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showCommentButton"
          type="button"
          class="btn-icon group-hover:visible btn-icon-default invisible mr-1 shrink-0"
          aria-label="Edit variance comment"
          @click.stop="editVarianceComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          {{ hasVariance ? `${australianNumber(variance)}${tradeItem.unit}` : '' }}

          <p
            v-if="hasVariance"
            class="text-xs text-gray-600"
          >
            {{ $tcc(variance * packageTradeItem.rate) }}
          </p>
        </div>
      </div>
    </td>

    <td class="bg-green-200/50">
      {{ australianNumber(packageTradeItem.previous(claim)) }}{{ tradeItem.unit }}
      <p class="text-xs text-gray-600">
        {{ $tcc(packageTradeItem.previous(claim) * packageTradeItem.rate) }}
      </p>
    </td>

    <td class="bg-green-200/50 pr-3">
      {{ australianNumber(packageTradeItem.previous(claim) + (ratesCost?.current_certified || 0)) }}{{ tradeItem.unit }}
      <p
        class="text-xs text-gray-600"
      >
        {{ $tcc((packageTradeItem.previous(claim) + (ratesCost?.current_certified || 0)) * packageTradeItem.rate) }}
      </p>
    </td>

    <td
      v-if="showPercentages && !falsey(ratesCost?.current_quantity) && canEditClaim && !typingClaim"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-blue-100/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.claimPercentage') + ': ' + (!falsey(ratesCost?.current_quantity) ? `${$tn((ratesCost.current_quantity / packageTradeItem.quantity) * 100)}%` : '')"
      @click="typeClaimPercent"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.removeClaim')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.editClaim')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(ratesCost?.current_quantity) ? `${$tn((ratesCost.current_quantity / packageTradeItem.quantity) * 100)}%` : '' }}
      </div>
    </td>

    <td
      v-else-if="showPercentages && canEditClaim"
      class="bg-blue-100/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.claimPercentage') + ': ' + $t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.editClaim')"
    >
      <div class="">
        <AppInput
          ref="claimPercentInput"
          v-model.number="currentClaimPercent"
          name="current_quantity_percent"
          type="number"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingClaim = false"
        />
      </div>
    </td>

    <td
      v-else-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.claimPercentage') + ': ' + (!falsey(ratesCost?.current_quantity) ? `${$tn((ratesCost.current_quantity / packageTradeItem.quantity) * 100)}%` : '')"
    >
      {{ !falsey(ratesCost?.current_quantity) ? `${$tn((ratesCost.current_quantity / packageTradeItem.quantity) * 100)}%` : '' }}
    </td>

    <td
      v-else
      class="bg-blue-100/50"
    />

    <template v-if="showPercentages && liteMode">
      <td
        v-if="!falsey(ratesCost?.current_certified) && !typingCertified && canEditCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-blue-100/50"
        @click="typeCertifiedPercent"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.removeCertified')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(ratesCost?.current_certified) ? $tp((ratesCost.current_certified / packageTradeItem.quantity) * 100) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified"
        class="bg-blue-100/50"
      >
        <div class="">
          <AppInput
            ref="certifiedPercentInput"
            v-model.number="currentCertifiedPercent"
            name="current_certified_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="resetTypingCertified"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-blue-100/50"
      >
        {{ !falsey(ratesCost?.current_certified) ? $tp((ratesCost.current_certified / packageTradeItem.quantity) * 100) : '' }}
      </td>
    </template>

    <template v-else-if="showPercentages">
      <td
        v-if="!falsey(ratesCost?.current_certified) && !typingCertified && canEditCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-blue-100/50"
        @click="typeCertifiedPercent"
      >
        <div class="group flex items-center justify-end">
          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(ratesCost?.current_certified) ? $tp((ratesCost.current_certified / packageTradeItem.quantity) * 100) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified && ratesCost"
        class="bg-blue-100/50"
      >
        <div class="">
          <AppInput
            ref="certifiedPercentInput"
            v-model.number="currentCertifiedPercent"
            name="current_certified_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="resetTypingCertified"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-blue-100/50"
      >
        {{ !falsey(ratesCost?.current_certified) ? $tp((ratesCost.current_certified / packageTradeItem.quantity) * 100) : '' }}
      </td>
    </template>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
    >
      {{ $tp((previousAmount / packageTradeItem.quantity) * 100) }}
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50 pr-3"
    >
      {{ $tp(((previousAmount + (ratesCost?.current_certified || 0)) / packageTradeItem.quantity) * 100) }}
    </td>

    <td class="pr-3">
      {{ $tn(Math.max(packageTradeItem.quantity - packageTradeItem.previous(claim) - (ratesCost?.current_certified || 0), 0)) }}{{ tradeItem.unit }}

      <p class="text-xs text-gray-600">
        {{ $tcc(Math.max((packageTradeItem.quantity - packageTradeItem.previous(claim) - (ratesCost?.current_certified || 0)) * packageTradeItem.rate, 0)) }}
      </p>
    </td>

    <td
      class="bg-orange-200/30 relative z-10"
    >
      <span v-if="showForecasts">{{ australianCurrency(packageTradeItem.baseline_forecast_amount || 0) }}</span>
    </td>

    <td
      v-if="showForecasts && !typingCurrentForecast && canEditActualForecast"
      :class="{ 'cursor-pointer': canEditActualForecast }"
      class="bg-orange-200/30 relative z-10 pr-3"
      @click="typeCurrentForecast"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="'Edit Actual Forecast'"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>

        <span class="ml-2">
          <p>{{ australianCurrency(getActualForecastValue()) }}</p>

          <p
            v-if="packageTradeItem.previousActualForecastForClaim(claim) !== 0"
            class="text-xs"
            :class="[packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
          >
            {{ australianCurrency(packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim)) }} m-1
          </p>
        </span>
      </div>
    </td>

    <td
      v-else-if="showForecasts && typingCurrentForecast"
      class="bg-orange-200/30 relative z-10 pr-3"
    >
      <div class="">
        <AppCurrencyInput
          ref="currentForecastInput"
          v-model.number="currentForecastForm.form.forecast_amount"
          name="forecast_amount"
          type="number"
          min="0"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingCurrentForecast"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingCurrentForecast = false"
        />

        <p
          v-if="packageTradeItem.previousActualForecastForClaim(claim) !== 0"
          class="text-xs"
          :class="[packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
        >
          {{ australianCurrency(packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim)) }} m-1
        </p>
      </div>
    </td>

    <td
      v-else-if="showForecasts"
      class="bg-orange-200/30 relative z-10 pr-3"
    >
      <p>
        {{ australianCurrency(getActualForecastValue()) }}
      </p>

      <p
        v-if="packageTradeItem.previousActualForecastForClaim(claim) !== 0"
        class="text-xs"
        :class="[packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
      >
        {{ australianCurrency(packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim)) }} m-1
      </p>
    </td>
  </tr>
</template>

<script setup lang="ts">
import ProvisionalSumBadge from '@/components/shared/ProvisionalSumBadge.vue';
import { useFormData } from '@/composables/useFormData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, australianNumber, falsey, roundDecimals } from '@/helpers';
import { t, tcc, tn } from '@/i18n';
import Claim, { ClaimStatus } from '@/models/Claim';
import PackageTradeItem from '@/models/PackageTradeItem';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import { useCommentsStore } from '@/store/comments';
import { usePackageTradeItemsStore } from '@/store/packageTradeItems';
import { useProjectsStore } from '@/store/projects';
import { useRatesCostsStore } from '@/store/ratesCosts';
import { useWbsCodesStore } from '@/store/wbsCodes';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, useTemplateRef, watch } from 'vue';
import { toast } from 'vue3-toastify';

const props = withDefaults(
  defineProps<{
    trade?: Trade;
    claim: Claim;
    tradeItem: TradeItem;
    projectId: string;
    packageTradeItem: PackageTradeItem;
    canEditCertified: boolean;
    liteMode?: boolean;
    showPercentages?: boolean;
    showForecasts?: boolean;
    depth?: number;
  }>(),
  {
    liteMode: false,
    depth: 0,
  },
);

const ratesCostsStore = useRatesCostsStore();
const projectsStore = useProjectsStore();
const wbsCodesStore = useWbsCodesStore();

const ratesCost = computed(() => {
  return ratesCostsStore.models
    .where('trade_item_id', props.tradeItem.id)
    .where('claim_id', props.claim.id)
    .with('comments')
    .first();
});

const wbsCode = computed(() => {
  return wbsCodesStore.models.find(props.packageTradeItem.wbs_code_id);
});

const varianceComment = computed(() => {
  return ratesCost.value?.comments?.[0];
});

const isOptionalComment = computed(() => {
  if(!ratesCost.value) {
    return false;
  }

  const claim = ratesCost.value.current_quantity;
  const certified = ratesCost.value.current_certified;

  if(falsey(claim) || falsey(certified)) {
    return false;
  }

  return claim === certified;
});

const variance = computed(() => {
  return ratesCost.value?.current_quantity - ratesCost.value?.current_certified;
});

const hasVariance = computed(() => {
  return !falsey(ratesCost.value?.current_quantity) && !falsey(ratesCost.value?.current_certified);
});

const canEditClaim = computed(() => {
  return props.liteMode && props.claim.status === ClaimStatus.draft;
});

const canEditActualForecast = computed(() => {
  return (props.liteMode && props.claim.status === ClaimStatus.draft) || props.claim.status !== ClaimStatus.certified;
});

const typingCertified = ref(falsey(ratesCost.value?.current_certified));
const typingClaim = ref(falsey(ratesCost.value?.current_quantity));
const claimInput = ref();
const claimPercentInput = ref();
const certifiedInput = ref();
const certifiedPercentInput = ref();

const costForm = useFormData({
  id: undefined,
  comment_trade: false,
  current_certified: undefined,
  current_quantity: undefined,
  comment: undefined,
});

const previousAmount = computed(() => {
  return props.packageTradeItem.previous(props.claim);
});

const currentClaimPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_quantity / props.packageTradeItem.quantity) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.packageTradeItem.quantity * 100) === 100) {
      costForm.form.current_quantity = props.packageTradeItem.quantity - previousAmount.value;

      return;
    }

    costForm.form.current_quantity = roundDecimals((value / 100) * props.packageTradeItem.quantity);
  },
});

const currentCertifiedPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_certified / props.packageTradeItem.quantity) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.packageTradeItem.quantity * 100) === 100) {
      costForm.form.current_certified = props.packageTradeItem.quantity - previousAmount.value;

      return;
    }

    costForm.form.current_certified = roundDecimals((value / 100) * props.packageTradeItem.quantity);
  },
});

const typeClaim = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    if(ratesCost.value) {
      costForm.form.current_quantity = ratesCost.value.current_quantity;
    }

    nextTick(() => {
      claimInput.value?.focusInput();
    });
  }
};

const typeClaimPercent = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    if(ratesCost.value) {
      costForm.form.current_quantity = ratesCost.value.current_quantity;
    }

    nextTick(() => {
      claimPercentInput.value?.focusInput();
    });
  }
};

const typeCertified = () => {
  if(props.canEditCertified) {
    typingCertified.value = true;

    if(ratesCost.value) {
      costForm.form.current_certified = ratesCost.value.current_certified;
    }

    nextTick(() => {
      certifiedInput.value?.focusInput();
    });
  }
};

const typeCertifiedPercent = () => {
  if(props.canEditCertified) {
    typingCertified.value = true;

    if(ratesCost.value) {
      costForm.form.current_certified = ratesCost.value.current_certified;
    }

    nextTick(() => {
      certifiedPercentInput.value?.focusInput();
    });
  }
};

watch(() => props.packageTradeItem.actualForecastForClaim(props.claim), (newValue) => {
  if(!typingCurrentForecast.value) {
    currentForecastForm.form.forecast_amount = newValue;
  }
});

watch(ratesCost, (newValue) => {
  if(newValue) {
    costForm.setData(newValue);
  }
}, { immediate: true });

const storeSingleCertifiedAction = useStoreApiAction(ratesCostsStore.saveCertifiedCost);
const storeRatesCostAction = useStoreApiAction(ratesCostsStore.create);
const updateRatesCostAction = useStoreApiAction(ratesCostsStore.update);
const updateCommentAction = useStoreApiAction(ratesCostsStore.updateComment);
const storeCommentAction = useStoreApiAction(ratesCostsStore.storeComment);
const deleteCommentAction = useStoreApiAction(ratesCostsStore.deleteComment);
const deleteRatesCostAction = useStoreApiAction(ratesCostsStore.delete);

const deleteCost = () => {
  deleteRatesCostAction.request(ratesCost.value.id).then(() => {
    costForm.form.current_certified = undefined;
    costForm.form.current_quantity = undefined;
    typingCertified.value = true;
    typingClaim.value = true;
  }).catch((_error) => {
    Swal.fire({
      icon: 'error',
      title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.somethingWentWrong'),
    });
  });
};

const removeCertified = () => {
  if(falsey(ratesCost.value.current_quantity)) {
    deleteCost();
  } else {
    updateRatesCostAction.request(ratesCost.value.id, { current_certified: undefined })
      .then((tradeItemCost) => {
        typingCertified.value = true;
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_certified = ratesCost.value.current_certified;
      });
  }
};

const updateLiteCertified = async () => {
  if(
    (falsey(costForm.form.current_certified) && !ratesCost.value) ||
    !typingCertified.value
  ) {
    return;
  }

  if(roundDecimals(costForm.form.current_certified + previousAmount.value) > props.packageTradeItem.quantity) {
    const budgetDifference = roundDecimals(costForm.form.current_certified + previousAmount.value) -
      props.packageTradeItem.quantity;

    const allowOverBudget = projectsStore.project?.head_contract_settings?.allow_certified_over_budget;

    if(allowOverBudget) {
      const result = await Swal.fire({
        icon: 'warning',
        title: 'Total exceeds budget.',
        text:
          `The total amount is greater than the budget. It is recommended that you create a variation to capture the remaining overflow ${
            tn(budgetDifference)
          }${props.tradeItem.unit}`,

        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      });

      if(!result.isConfirmed) {
        return;
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid amount.',
        text:
          `The certified amount cannot be greater than the budget. It is recommended that you create a variation to capture the remaining overflow ${
            tn(budgetDifference)
          }${props.tradeItem.unit}`,
      });

      costForm.resetData(['current_certified']);

      return;
    }
  }

  // if user clears certified and claim is also cleared, delete the cost
  if(falsey(costForm.form.current_certified) && ratesCost.value && falsey(ratesCost.value.current_quantity)) {
    deleteRatesCostAction.request(ratesCost.value.id).then(() => {
      typingCertified.value = false;
    }).catch((_error) => {
      Swal.fire({
        icon: 'error',
        title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.somethingWentWrong'),
      });

      typingCertified.value = true;
    });
  } else if(ratesCost.value) {
    // if the cost exists
    costForm.resetData(['comment']);
    let commentSet = true;

    // if current certified is set and incoming new claim != current certified, require comment
    if(
      !falsey(ratesCost.value.current_quantity) &&
      costForm.form.current_certified !== ratesCost.value.current_quantity
    ) {
      commentSet = false;

      const comment = await Swal.fire({
        icon: 'warning',
        title: 'Reason for Adjustment',
        text: 'Please provide a reason for the variance between the claim and certified amounts.',
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
        showCancelButton: true,
      });

      if(comment.isConfirmed) {
        commentSet = true;
      }

      costForm.form.comment = comment?.value;
    }

    if(commentSet) {
      updateRatesCostAction.request(ratesCost.value.id, {
        current_certified: costForm.form.current_certified,
        comment: costForm.form.comment,
      })
        .then((_ratesCost) => {
          if(falsey(ratesCost.value?.current_certified)) {
            typingCertified.value = true;
          } else {
            typingCertified.value = false;
          }
        }).catch((error) => {
          if(error.status === 422) {
            Swal.fire({
              icon: 'error',
              title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidData'),
              text: error.data.message,
            });
          }

          costForm.form.current_certified = ratesCost.value.current_certified;

          typingCertified.value = true;
        });
    }
  } else {
    storeRatesCostAction.request(props.claim.id, props.tradeItem.id, costForm.form).then((ratesCost) => {
      typingCertified.value = false;
    }).catch((error) => {
      console.log(error);

      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
          text: error.data.message,
        });
      }

      typingCertified.value = true;
    });
  }
};

const updateCertified = async () => {
  if(costForm.form.current_certified > props.packageTradeItem.quantity) {
    const budgetDifference = costForm.form.current_certified - props.packageTradeItem.quantity;
    const allowOverBudget = projectsStore.project?.head_contract_settings?.allow_certified_over_budget;

    if(allowOverBudget) {
      const result = await Swal.fire({
        icon: 'warning',
        title: 'Total exceeds budget.',
        text:
          `The total amount is greater than the budget. It is recommended that you create a variation to capture the remaining overflow ${
            tn(budgetDifference)
          }${props.tradeItem.unit}`,

        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      });

      if(!result.isConfirmed) {
        return;
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid amount.',
        text:
          `The certified amount cannot be greater than the budget. It is recommended that you create a variation to capture the remaining overflow ${
            tn(budgetDifference)
          }${props.tradeItem.unit}`,
      });

      costForm.resetData(['current_certified']);

      return;
    }
  }

  if(costForm.form.current_certified !== ratesCost.value?.current_certified) {
    let commentSet = true;

    if(costForm.form.current_certified !== ratesCost.value?.current_quantity) {
      commentSet = false;

      const comment = await Swal.fire({
        icon: 'warning',
        title: 'Reason for Adjustment',
        text: 'Please provide a reason for the variance between the claim and certified amounts.',
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
        showCancelButton: true,
      });

      if(comment.isConfirmed) {
        commentSet = true;
      }

      costForm.form.comment = comment?.value;
    } else {
      costForm.form.comment = undefined;
    }

    if(commentSet) {
      // Save the certified amount
      storeSingleCertifiedAction.request(props.projectId, props.claim.id, ratesCost.value.id, costForm.form)
        .then(
          (_ratesCost) => {
            // console.log('Certified amount updated:', ratesCost);
          },
        ).catch((error) => {
          if(error.status === 422) {
            Swal.fire({
              icon: 'error',
              title: 'Invalid data.',
              text: error.data.message,
            });
          }

          costForm.form.current_certified = ratesCost.value?.current_certified;
        });
    } else {
      costForm.form.current_certified = ratesCost.value?.current_certified;
    }
  }

  typingCertified.value = false;
};

const stopTypingCertified = async () => {
  if(props.liteMode) {
    updateLiteCertified();
  } else {
    updateCertified();
  }
};

const stopTypingClaim = async () => {
  // if claim not set and the cost does not exist, then don't continue
  if(
    (falsey(costForm.form.current_quantity) && !ratesCost.value) ||
    !typingClaim.value
  ) {
    return;
  }

  // if both have been cleared out, delete the cost
  if(falsey(costForm.form.current_quantity) && ratesCost.value && falsey(ratesCost.value.current_certified)) {
    deleteRatesCostAction.request(ratesCost.value.id).then(() => {
      typingClaim.value = true;
    }).catch((_error) => {
      typingClaim.value = false;
    });
  } else if(ratesCost.value) {
    // updating existing cost current_quantity
    costForm.resetData(['comment']);
    let commentSet = true;

    // if current certified is set and incoming new claim != current certified, require comment
    if(
      !falsey(ratesCost.value.current_certified) &&
      costForm.form.current_quantity !== ratesCost.value.current_certified
    ) {
      commentSet = false;

      const comment = await Swal.fire({
        icon: 'warning',
        title: 'Reason for Adjustment',
        text: 'Please provide a reason for the variance between the claim and certified amounts.',
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
        showCancelButton: true,
      });

      if(comment.isConfirmed) {
        commentSet = true;
      }

      costForm.form.comment = comment?.value;
    }

    if(commentSet) {
      updateRatesCostAction.request(ratesCost.value.id, {
        current_quantity: costForm.form.current_quantity,
        comment: costForm.form.comment,
      })
        .then((_ratesCost) => {
          if(falsey(ratesCost.value.current_quantity)) {
            typingClaim.value = true;
          } else {
            typingClaim.value = false;
          }
        }).catch((error) => {
          if(error.status === 422) {
            Swal.fire({
              icon: 'error',
              title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidData'),
              text: error.data.message,
            });
          }

          costForm.form.current_quantity = ratesCost.value.current_quantity;
          typingClaim.value = true;
        });
    }
  } else {
    storeRatesCostAction.request(props.claim.id, props.tradeItem.id, costForm.form).then((_ratesCost) => {
      typingClaim.value = false;
    }).catch((error) => {
      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
          text: error.data.message,
        });
      }

      typingClaim.value = true;
    });
  }
};

const removeClaim = () => {
  if(falsey(ratesCost.value.current_certified)) {
    deleteCost();
  } else {
    updateRatesCostAction.request(ratesCost.value.id, { current_quantity: undefined })
      .then((updatedRatesCost: { current_quantity?: number } | unknown) => {
        typingClaim.value = true;

        costForm.form.current_quantity = (updatedRatesCost as { current_quantity?: number }).current_quantity ??
          ratesCost.value?.current_quantity;
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_quantity = ratesCost.value.current_quantity;
      });
  }
};

const resetTypingCertified = () => {
  typingCertified.value = false;
  costForm.form.current_certified = ratesCost.value?.current_certified || 0;
};

const packageTradeItemsStore = usePackageTradeItemsStore();
const typingCurrentForecast = ref(false);

const getActualForecastValue = () => {
  return props.packageTradeItem.actualForecastForClaim(props.claim);
};

const currentForecastForm = useFormData({
  forecast_amount: getActualForecastValue(),
});

const currentForecastInput = useTemplateRef('currentForecastInput');
const updateForecastAmountsAction = useStoreApiAction(packageTradeItemsStore.updateForecastAmounts);

const typeCurrentForecast = () => {
  if(canEditActualForecast.value) {
    typingCurrentForecast.value = true;

    currentForecastForm.setData({
      forecast_amount: getActualForecastValue(),
    });

    nextTick(() => {
      currentForecastInput.value?.focusInput();
    });
  }
};

const stopTypingCurrentForecast = async () => {
  if(
    (falsey(currentForecastForm.form.forecast_amount) && getActualForecastValue() === 0) ||
    !typingCurrentForecast.value
  ) {
    typingCurrentForecast.value = false;
    currentForecastForm.form.forecast_amount = getActualForecastValue();

    return;
  }

  updateForecastAmountsAction.request(props.packageTradeItem.id, {
    actual_forecast_amount: currentForecastForm.form.forecast_amount,
  }).then(() => {
    typingCurrentForecast.value = false;
  }).catch((error) => {
    if(error.status === 422) {
      Swal.fire({
        icon: 'error',
        title: t('Subcontract.SubcontractorClaimShow.RatesTradeRowItem.error.invalidAmount'),
        text: error.data.message,
      });
    }

    currentForecastForm.form.forecast_amount = getActualForecastValue();
    typingCurrentForecast.value = true;
  });
};

const showCommentButton = computed(() => {
  return hasVariance.value && variance.value !== 0 && !!varianceComment.value && props.canEditCertified;
});

const showBudgetCommentButton = computed(() => {
  return props.canEditCertified &&
    !falsey(ratesCost.value) &&
    !falsey(ratesCost.value.current_certified) &&
    !falsey(ratesCost.value.current_quantity);
});

const showBudgetCommentTooltip = computed(() => {
  return !!varianceComment.value?.body && showBudgetCommentButton.value;
});

const showBudgetcomment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ? 'Reason for Adjustment' : 'Comment',
    text: varianceComment.value?.body,
  });
};

const editBudgetComment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ? 'Reason for Adjustment' : 'Comment',
    text: (hasVariance.value && variance.value !== 0) ?
      'Please provide a reason for the variance between the claim and certified amounts.' :
      'Provide an optional comment for the cost.',

    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: varianceComment.value ? 'Update' : 'Save',
    showDenyButton: isOptionalComment.value && !!varianceComment.value,
    denyButtonText: 'Delete',
    denyButtonColor: '#d33',
  }).then((result) => {
    if(result.isDenied && varianceComment.value) {
      deleteCommentAction.request(ratesCost.value.id, varianceComment.value.id).then(() => {
        toast.success('Comment deleted');
      });
    } else if(result.isConfirmed && result.value) {
      if(varianceComment.value) {
        updateCommentAction.request(ratesCost.value.id, varianceComment.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment updated');
          },
        );
      } else {
        storeCommentAction.request(ratesCost.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment saved');
          },
        );
      }
    }
  });
};

const editVarianceComment = () => {
  Swal.fire({
    icon: 'warning',
    title: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentTitle'),
    text: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentText'),
    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: 'Update',
  }).then((result) => {
    if(result.isConfirmed) {
      if(result.value) {
        updateCommentAction.request(ratesCost.value.id, varianceComment.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment updated');
          },
        );
      }
    }
  });
};
</script>

<style scoped></style>
